import { jsx as _jsx } from "react/jsx-runtime";
import { units } from "@m/alchemy-theme";
export const emptyDash = "–";
export const emptyCharacter = _jsx("span", { "aria-hidden": "true", children: emptyDash });
export const emptyCharacterIfEmpty = (children) => children === false || children === null || children === undefined ? emptyCharacter : null;
export const horizontalPaddingUnits = 0.8;
export const verticalPaddingUnits = 1.25;
export const paragraphTextWidth = "70vw";
export const cellPadding = `${units(verticalPaddingUnits)} ${units(horizontalPaddingUnits)}`;
